/* eslint-disable eqeqeq, func-names, max-len, no-new, no-plusplus, no-shadow, no-underscore-dangle */
/* global NetC:false */
import Bloodhound from 'bloodhound';
import 'typeahead.jquery';

(() => {
  if (!$('.pos').length) {
    return;
  }

  // Keep product selection code to the top - everything else below
  const $searchBox = $('.pos-search-box input[type=text]');
  const culture = $('#lng').val();
  const $ajaxLoader = $('.ajaxLoader').parent();

  const templates = {
    productItem: require('templates/pos-products.hbs'),
    productModel: require('templates/pos-models.hbs'),
    productSearch: require('templates/pos-search.hbs'),
    productSelected: require('templates/pos-selected.hbs'),
  };

  const count = 10;

  const $posCreate = $('.pos-create');
  const $loadMoreBtn = $('.btn-load-more');
  const $section = $('.pos-cat-top');
  const $tagTotal = $('.download-tag-area .items count');
  const $searchResults = $('.pos-product-area.search');
  const $basketPop = $('.tag-basket-pop');

  let $posRemove = $('.pos-remove');
  let $productTitle = $('.pos-prod-top');
  let $productAdd = $('.btn-add-product');
  let currentProduct = 0;
  let currentProductAliasPath = '';
  let currentSection = 0;
  let currentSectionAliasPath = '';
  let searchAliasPath = '';
  let searchStartIndex = 0;
  let searchCount = 0;
  let startIndex = 0;

  // Set size dropdown width based on text length
  let dropTextLen = 0;
  let dropWidth = 0;
  $('.tag-pop-choices select option').each(function () {
    const currentLen = $(this).html().length;
    if (currentLen > dropTextLen) {
      dropTextLen = currentLen;
    }
  });
  dropWidth = (dropTextLen * 20);
  if (dropWidth > 335) {
    dropWidth = 335;
  }
  setTimeout(() => {
    $('.tag-pop-choices .chosen-container').attr('style', `width: ${dropWidth}px !important`);
  }, 200);

  init();

  // Additional page functions

  // resize boxes in a row to be same
  if ($('.pos-box').length) {
    const boxtopresize = function boxtopresize() {
      $('.pos-box-top').css('height', 'auto');
      let boxtopheight = 0;
      $('.pos-box').each(() => {
        $('.pos-box-top').each(function () {
          if ($(this).outerHeight() > boxtopheight) {
            boxtopheight = ($(this).outerHeight());
            $('.pos-box-top').css('height', boxtopheight);
          }
        });

        $('.pos-box-top').css('height', boxtopheight);
      });
    };
    if ($(window).innerWidth() > 767) {
      boxtopresize();
    }
    $(window).resize(() => {
      if ($(window).innerWidth() > 767) {
        boxtopresize();
      }
    });
  }

  if ($('.pop-up-over').length) {
    const fadeInPopUp = function fadeInPopUp() {
      $('.pop-up-over').show();

      const windowHeight = $(window).height();
      const popUpHeight = $basketPop.outerHeight();
      const popUpHeightHalf = ($basketPop.outerHeight() / 2);

      $('.pop-up-over').css({ 'z-index': '1000' });
      if (windowHeight > (popUpHeight + popUpHeightHalf)) {
        $basketPop.css({
          'margin-top': -popUpHeightHalf,
        });
      } else {
        $basketPop.css({ top: '0' });
      }

      $('.pop-up-over').animate({
        opacity: 1,
      }, 400, () => {
        $basketPop.animate({
          opacity: 1,
        }, 400);
      });

      // adds class to outer container so shows basket bar at bottom (if not already there)
      if (!$('.pos-create').hasClass('withBasket')) {
        $('.pos-create').addClass('withBasket');
      }
    };

    // on click  of add to basket link fade in overlay basket
    $('.pos-add').click(() => {
      fadeInPopUp();
    });

    // on click  of basket link fade in overlay basket
    $('.basket-link, .download-tags').click((e) => {
      e.preventDefault();

      GetSelectedProductDetails();
      fadeInPopUp();
    });

    // on click of close basket, it fades out overlay basket
    $('.close-tag-basket').click(() => {
      $basketPop.animate({
        opacity: 0,
      }, 400, () => {
        $basketPop.animate({
          opacity: 0,
        }, 400, () => {
          $('.pop-up-over').removeAttr('style');
          $basketPop.removeAttr('style');
        });
      });
    });
  }

  // Get search result products
  function loadSearchProducts(append) {
    // remove end slash
    if (searchAliasPath.substr(searchAliasPath.length - 1, 1) == '/') {
      searchAliasPath = searchAliasPath.substr(0, searchAliasPath.length - 1);
    }

    $ajaxLoader.css('visibility', 'visible');

    NetC.PointOfSale.GetSearchProducts(searchAliasPath, searchStartIndex, searchCount, (resp) => {
      const $wrapper = $('#section_search .pos-cat-main');

      // clear existing items
      if (append !== true) {
        $wrapper.empty();
      }

      // apply template and append items
      const formattedHtml = $.trim(templates.productSearch(resp.Data));

      $wrapper.append(formattedHtml);

      let nodeId = 0;
      if (resp.Data.Products !== null) {
        nodeId = parseInt(resp.Data.Products[0].ProductNodeID, 10) || 0;
      }

      if (nodeId > 0) {
        currentProductAliasPath = searchAliasPath;
        currentProduct = nodeId;
        loadProductModels(true);
      }

      if ($searchResults.show() === false) {
        $searchResults.slideDown();
      }

      $ajaxLoader.css('visibility', 'hidden');
    }, () => {
      $ajaxLoader.css('visibility', 'hidden');
    });
  }

  // Get products
  function loadProducts(append) {
    $ajaxLoader.css('visibility', 'visible');
    NetC.PointOfSale.GetSectionProducts(currentSectionAliasPath, startIndex, count, (resp) => {
      const $wrapper = $(`#section_${currentSection} .pos-cat-main`);

      // clear existing items
      if (append !== true) {
        $wrapper.empty();
      }

      // apply template and append items
      const formattedHtml = $.trim(templates.productItem(resp.Data));

      $wrapper.append(formattedHtml);

      if (resp.Data.ShowLoadMore === true) {
        $wrapper.next('.btn-load-more').removeClass('hidden');
      } else {
        $wrapper.next('.btn-load-more').addClass('hidden');
      }

      $productTitle = $('.pos-prod-top');
      $productTitle.unbind();
      $productTitle.click(function (e) {
        e.preventDefault();
        currentProductAliasPath = $(this).attr('data-url');
        currentProduct = $(this).attr('data-id');

        loadProductModels(false);

        $(this).siblings('.pos-prod-main').slideToggle();
        $(this).parent('.pos-prod').toggleClass('open-pos');
      });

      $ajaxLoader.css('visibility', 'hidden');
    }, () => {
      $ajaxLoader.css('visibility', 'hidden');
    });
  }

  // Get product models
  function loadProductModels(isSearch) {
    let $wrapper;

    if (isSearch) {
      $wrapper = $('#models_search');
    } else {
      $wrapper = $(`#models_${currentProduct}`);
    }

    // $ajaxLoader.css('visibility', 'visible'); // loads fast enough not to require this

    // Only get products once
    if ($wrapper.html().length === 0) {
      NetC.PointOfSale.GetProductModels(currentProductAliasPath, currentProduct, (resp) => {
        // apply template and append items
        $wrapper.append($.trim(templates.productModel(resp.Data)));

        GetSelectedProduct();

        $productAdd = $('.pos-add');
        $productAdd.unbind();
        $productAdd.click(function (e) {
          e.preventDefault();
          let nodeId = 0;
          let quantity = 0;

          const $tagId = $(this).attr('id').replace('tagAdd_', '');
          if (!isNaN($tagId) && $tagId.length > 0) {
            nodeId = $tagId;
          }

          const $tagQty = $(`#${$(this).attr('id').replace('tagAdd', 'tagQty')}`).val();
          if (!isNaN($tagQty) && $tagQty.length > 0) {
            quantity = $tagQty;
          }

          UpdateSelectedProduct(nodeId, quantity);
        });
      });
    }
  }

  // Get selected products
  function GetSelectedProduct() {
    NetC.PointOfSale.GetSelectedProducts((resp) => {
      if (resp.Data !== null) {
        UpdateInputs(resp.Data);
      }
    });
  }

  // Update selected products
  function UpdateSelectedProduct(nodeId, quantity) {
    NetC.PointOfSale.UpdateSelectedProducts(nodeId, quantity, (resp) => {
      if (resp.Data !== null) {
        UpdateInputs(resp.Data);
      }
    });
  }

  function UpdateInputs(data) {
    let tagCount = 0;
    $.each(data, (index, value) => {
      if (index == 'FactTags') {
        $.each(value, (index, item) => {
          const $tagInput = $(`#tagQty_${item.TagNodeID}`);
          const $tagBtn = $(`#tagAdd_${item.TagNodeID}`);
          const $myTagInput = $(`#myTagQty_${item.TagNodeID}`);

          // product search inputs
          if ($tagInput.length > 0) {
            if (item.TagQty > 0) {
              $tagInput.val(item.TagQty);
              $myTagInput.val(item.TagQty);
              $tagBtn.text($tagBtn.attr('data-added'));
            } else {
              $tagInput.val('');
              $myTagInput.val('');
              $tagBtn.text($tagBtn.attr('data-add'));
            }
          }

          // basket inputs
          if ($myTagInput.length > 0) {
            if (item.TagQty > 0) {
              $myTagInput.val(item.TagQty);
            } else {
              $myTagInput.val('');
            }

            // on basket input change update
            $myTagInput.unbind();
            $myTagInput.on('input', function () {
              const myTagNodeId = parseInt($(this).attr('id').replace('myTagQty_', ''), 10) || 0;
              const myTagQty = parseInt($(this).val(), 10) || 0;

              UpdateSelectedProduct(myTagNodeId, myTagQty);
            });
          }

          if (item.TagNodeID > 1 && item.TagQty > 0) {
            tagCount++;
          }
        });
      }
    });

    $tagTotal.text(tagCount);

    if (tagCount > 0) {
      $posCreate.addClass('withBasket');
    } else {
      // Hide basket popup if open
      if ($basketPop.css('opacity') == 1) {
        $basketPop.animate({
          opacity: 0,
        }, 400, () => {
          $basketPop.animate({
            opacity: 0,
          }, 400, () => {
            $('.pop-up-over').removeAttr('style');
            $basketPop.removeAttr('style');
          });
        });
      }

      $posCreate.removeClass('withBasket');
    }
  }

  // Get selected product information
  function GetSelectedProductDetails() {
    NetC.PointOfSale.GetSelectedProductDetails((resp) => {
      if (resp.Data.FactTags !== null) {
        const $wrapper = $('.tag-pop-white-inner');

        // clear existing items
        $wrapper.empty();

        // apply template and append items
        const formattedHtml = $.trim(templates.productSelected(resp.Data));

        $wrapper.append(formattedHtml);

        GetSelectedProduct();

        $posRemove = $('.pos-remove');
        $posRemove.unbind();
        $posRemove.click(function () {
          const myTagNodeId = parseInt($(this).attr('id').replace('myTagRemove_', ''), 10) || 0;
          UpdateSelectedProduct(myTagNodeId, 0);
        });
      }
    });
  }

  function init() {
    // Search box
    const placeholder = $searchBox.attr('placeholder');

    const source = new Bloodhound({
      datumTokenizer: Bloodhound.tokenizers.obj.whitespace('modelNumber'),
      identify: datum => datum.modelNumber,
      queryTokenizer: Bloodhound.tokenizers.whitespace,
      prefetch: '/api/typeahead/prefetch/',
    });

    const templates = {
      suggestion: require('templates/autocomplete-suggestion.hbs'),
    };

    $searchBox.typeahead(null, {
      display: 'modelName',
      name: `milwaukee-products-${culture}`,
      source,
      templates,
    });

    $searchBox.on('typeahead:selected', ($event, suggestion) => {
      searchAliasPath = suggestion.url;
      searchStartIndex = 0;
      searchCount = 10;
      loadSearchProducts(false);
      return false;
    });

    $searchBox.attr('placeholder', placeholder);

    // Products
    currentSectionAliasPath = $section.first().attr('data-url');
    currentSection = $section.first().attr('data-id');

    GetSelectedProductDetails();

    $section.click(function (e) {
      e.preventDefault();
      startIndex = 0;
      currentSectionAliasPath = $(this).attr('data-url');
      currentSection = $(this).attr('data-id');

      loadProducts(true);

      $(this).siblings('.pos-cat-main').slideToggle();
      $(this).siblings('.btn-load-more').slideToggle();
      $(this).parent('.pos-cat').toggleClass('open-pos');
    });

    $loadMoreBtn.click((e) => {
      e.preventDefault();
      startIndex += count;
      loadProducts(true);
    });
  }
})();
